import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetAllNotificationGroupsQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
  page: Types.PageInput;
  unreadOnly?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetAllNotificationGroupsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, allNotificationGroups: { __typename?: 'NotificationGroupConnection', mostRecentNotification?: { __typename?: 'Notification', id: string } | null, nodes: Array<{ __typename?: 'NotificationGroupAccessRequestApproved', id: string } | { __typename?: 'NotificationGroupAccessRequestDenied', id: string } | { __typename?: 'NotificationGroupAccessRequestSubmitted', id: string } | { __typename?: 'NotificationGroupAssetAssignedToYou', id: string } | { __typename?: 'NotificationGroupAssetStatusChanged', id: string } | { __typename?: 'NotificationGroupCommentCreated', id: string } | { __typename?: 'NotificationGroupCommentCreatedShareAccess', id: string } | { __typename?: 'NotificationGroupFileUploaded', id: string } | { __typename?: 'NotificationGroupReplyCreated', id: string } | { __typename?: 'NotificationGroupReplyCreatedShareAccess', id: string } | { __typename?: 'NotificationGroupRequesterAccessRequestApproved' } | { __typename?: 'NotificationGroupRequesterAccessRequestDenied' } | { __typename?: 'NotificationGroupTranscriptCompletedSelf' } | { __typename?: 'NotificationGroupTransferBatchCompleted', id: string } | { __typename?: 'NotificationGroupTransferBatchCompletedSelf', id: string } | { __typename?: 'NotificationGroupUserMentioned', id: string } | { __typename?: 'NotificationGroupUserMentionedShareAccess', id: string }> } } | null };


export const GetAllNotificationGroups = /*#__PURE__*/ gql`
    query GetAllNotificationGroups($accountId: ID!, $page: PageInput!, $unreadOnly: Boolean) {
  account(accountId: $accountId) {
    id
    allNotificationGroups: notificationGroups(
      page: $page
      filters: {unreadOnly: $unreadOnly}
    ) {
      mostRecentNotification {
        id
      }
      nodes {
        ... on NotificationGroupCommentCreated {
          id
        }
        ... on NotificationGroupFileUploaded {
          id
        }
        ... on NotificationGroupReplyCreated {
          id
        }
        ... on NotificationGroupTransferBatchCompleted {
          id
        }
        ... on NotificationGroupTransferBatchCompletedSelf {
          id
        }
        ... on NotificationGroupUserMentioned {
          id
        }
        ... on NotificationGroupAssetAssignedToYou {
          id
        }
        ... on NotificationGroupAssetStatusChanged {
          id
        }
        ... on NotificationGroupAccessRequestSubmitted {
          id
        }
        ... on NotificationGroupAccessRequestApproved {
          id
        }
        ... on NotificationGroupAccessRequestDenied {
          id
        }
        ... on NotificationGroupCommentCreatedShareAccess {
          id
        }
        ... on NotificationGroupReplyCreatedShareAccess {
          id
        }
        ... on NotificationGroupUserMentionedShareAccess {
          id
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<GetAllNotificationGroupsQuery, GetAllNotificationGroupsQueryVariables>;

          

          export const useGetAllNotificationGroupsQuery = (options?:QueryHookOptions<GetAllNotificationGroupsQuery, GetAllNotificationGroupsQueryVariables>) => useQuery(GetAllNotificationGroups, options);

          

          export type GetAllNotificationGroupsQueryOptions = QueryHookOptions<GetAllNotificationGroupsQuery, GetAllNotificationGroupsQueryVariables>;

          

          export const useGetAllNotificationGroupsLazyQuery = (options?:LazyQueryHookOptions<GetAllNotificationGroupsQuery, GetAllNotificationGroupsQueryVariables>) => useLazyQuery(GetAllNotificationGroups, options);

          

          export type GetAllNotificationGroupsQueryResult = ReturnType<typeof useGetAllNotificationGroupsQuery>;

          
